<template>
  <span
    class="highlight"
    v-on:click="toggleActive"
    v-bind:class="{ active: isActive }"
    v-scroll="disableActive"
  >
    <slot></slot>
  </span>
</template>
<script>
export default {
  name: "Highlight",
  components: {},
  props: {
    label: String,
  },
  data: function() {
    return {
      isActive: false,
    };
  },
  methods: {
    disableActive: function() {
      this.isActive = false;
    },
    toggleActive: function() {
      this.isActive = !this.isActive;
    },
  },
};
</script>
<style scoped>
.highlight {
  position: relative;
  font-size: 18px;
  border-bottom: 1.5px solid var(--BLACK);
}
</style>



// WEBPACK FOOTER //
// src/components/subpages/Highlight.vue